export default __webpack_public_path__ + "static/media/2054.ee44957e.png";